module.exports = __webpack_public_path__ + "static/img/A176.8efc27ab.jpg";